const router = [
  {
    path: '/consult-complaiont',
    name: 'ConsultComplaiont',
    component: () =>
      import('../views/ConsultComplaiont/ConsultComplaiont.vue')
  },
]
export default router
